import React from 'react';
import PropTypes from 'prop-types';

import MuiContainer from '@material-ui/core/Container';

/**
 * Default Container component based on https://material-ui.com/components/container/
 * @param {*} props All possible props can be found in docs https://material-ui.com/api/container/
 */
export default function Container(props) {
  const { ...rest } = props;

  return <MuiContainer maxWidth="lg" {...rest} />;
}

Container.propTypes = {
  /**
   * Max width of the container
   */
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
};

Container.defaultProps = {
  maxWidth: 'lg',
};
